import React from 'react';
import { Box, Typography } from '@mui/material';

export interface ChatComposerNoticeProps {
  /** Why the action is worth taking, e.g. "Run this again anytime, on the latest data". */
  text: string;
  /** The one thing to click. */
  action: React.ReactNode;
}

/**
 * A single line above the composer offering one next step — plain text for
 * the why, a button for the action — e.g. saving a chat as an agent.
 */
export function ChatComposerNotice({ text, action }: ChatComposerNoticeProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
      <Typography variant="caption" sx={(t) => ({ color: t.tokens.text.secondary })}>
        {text}
      </Typography>
      {action}
    </Box>
  );
}
